import { render, staticRenderFns } from "./brandArea.vue?vue&type=template&id=f1af67ec&scoped=true&"
import script from "./brandArea.vue?vue&type=script&lang=js&"
export * from "./brandArea.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./brandArea.vue?vue&type=style&index=0&id=f1af67ec&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "f1af67ec",
  "5b8749f4"
  
)

export default component.exports